module.exports = __webpack_public_path__ + "google-touch-icon-192x192-4c75311efecab17aee9ae5c96d900918.png";